// extracted by mini-css-extract-plugin
export default {"container":"InputTextAdmin-module_container__2gJ3Ma"};